import { Col, Row, Grid } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import scaleupallyLogo from '../../assets/scaleupally_logo.svg';
import stripeLogo from '../../assets/stripe_logo.svg';
import AlmaLogo from '../../assets/alma_icon.svg';
import ScalapayLogo from '../../assets/scalapay.svg';

const { useBreakpoint } = Grid;

function Footer({ language }) {
  Footer.propTypes = {
    language: PropTypes.object,
  };

  const screens = useBreakpoint(); // Get current screen size

  return (
    <Row
      gutter={[16, 16]}
      className="footer"
      style={{
        flexDirection: screens.xs ? 'column' : 'row', // Stack on mobile, row on desktop
      }}
    >
      {/* ScaleUpAlly Section - Comes first in mobile view, stays on right in desktop */}
      <Col
        xs={24}
        md={12}
        style={{
          display: 'flex',
          justifyContent: screens.xs ? 'center' : 'flex-end', // Center on mobile
          order: screens.xs ? 0 : 1, // Move to top on mobile
        }}
      >
        <div className="title ">
          {language?.content?.DEVELOPED_BY}{' '}
          <a href="https://scaleup.ai" target="_blank" rel="noopener noreferrer">
            <img src={scaleupallyLogo} alt="ScaleUpAlly Logo" className="scaleupally-logo" />
          </a>
        </div>
      </Col>

      {/* Payment Partners Section - Comes below ScaleUpAlly section in mobile */}
      <Col
        xs={24}
        md={12}
        style={{
          display: 'flex',
          justifyContent: screens.xs ? 'center' : 'flex-start', // Center on mobile
          alignItems: 'center',
        }}
      >
        <div className="title left flex flex-column" style={{ gap: '10px' }}>
          <div
            className="title"
            style={{
              borderRight: screens.xs ? 'none' : '1px solid #707070', // Hide border in mobile
              padding: screens.xs ? '0' : '2px 10px',
            }}
          >
            {language?.content?.POWERED_BY}
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            <a href="https://stripe.com/" target="_blank" rel="noopener noreferrer">
              <img src={stripeLogo} alt="Stripe Logo" className="stripe-logo" />
            </a>

            <a href="https://stripe.com/" target="_blank" rel="noopener noreferrer">
              <img src={AlmaLogo} alt="Alma Logo" className="stripe-logo" />
            </a>

            <a href="https://scalapay.com/" target="_blank" rel="noopener noreferrer">
              <img src={ScalapayLogo} alt="Scalapay Logo" className="scalapay-logo" />
            </a>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default Footer;
